import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { resolveBreadCrumbPaths } from '../BreadCrumb/BreadCrumb';
import classNames from './BreadCrumbSp.module.scss';

export const BreadCrumbSp = ({ currentPage }: { currentPage?: string }) => {
  const router = useRouter();
  const { t } = useTranslation('common');

  return (
    <div className={classNames.breadcrumb}>
      <div className={classNames['home-anchor']}>
        <Link href="/">HOME</Link>
      </div>
      {resolveBreadCrumbPaths({ router, t }).map((path, i, paths) => {
        return (
          <>
            <div className={classNames.slash}>
              <span>／</span>
            </div>
            <div
              className={classNames.anchor}
              data-current={paths.length - 1 === i && !currentPage}
            >
              {path.href ? (
                <Link href={path.href}>{path.text}</Link>
              ) : (
                <span>{path.text}</span>
              )}
            </div>

            {currentPage && (
              <>
                <div className={classNames.slash}>
                  <span>／</span>
                </div>
                <div
                  className={classNames.anchor}
                  data-current
                  style={{
                    whiteSpace: 'wrap',
                  }}
                >
                  <span>{currentPage}</span>
                </div>
              </>
            )}
          </>
        );
      })}
    </div>
  );
};
